export default __webpack_public_path__ + "static/small-text-dont-e1e76486c258cbe824ac0b834b8935989e3aff9a30210add324778faaffa433f.png";